import { useEffect, useState } from 'react';
import axios from 'axios';

export default function ServiceSales(props) {

  // const [salesData, setSalesData] = useState([]);
  let salesData = [];
  let loadingSalesData = false;
  let Euro = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  });
  let salesRows = <tr>
    <td>---</td>
    <td>---</td>
    <td>---</td>
    <td>---</td>
  </tr>;

  let statusNames = {
    'test': 'Test',
    'free': 'Freiverkauf',
    'error': 'Fehler'
  };
  let paymentTypes = {
    'coin': 'Münze',
    'bill': 'Schein',
    'debitCard': 'Karte',
    'creditCard': 'Kreditkarte',
    'debitCostCenter': 'Kostenstelle',
    'creditCostCenter': 'Kostenstlele',
    'payroll': 'Lohn',
    'openloop': 'Open Loop',
    'app': 'App',
    'vendToken': 'Freiverkaufstoken',
    'valueToken': 'Werttoken',
    'other': 'Sonstige',
  }

  const [salesContent, setSalesContent] = useState(
    <table className="ui unstackable table">
      <thead>
        <tr>
          <th>Datum</th>
          <th>Wahl</th>
          <th>Preis</th>
          <th>Bezahlung</th>
        </tr></thead>
      <tbody>
        {salesRows}
      </tbody>
    </table>
  );

  const formatDate = (date) =>{
    let d=new Date(date);
    return `${d.getDate()}.${d.getMonth()+1}. `+d.toLocaleTimeString();
  }

  const updateSalesData = (localSalesData) => {
    salesRows = (localSalesData === undefined || localSalesData.length == 0 ?
      <tr>
        <td>---</td>
        <td>---</td>
        <td>---</td>
        <td>---</td>
      </tr>
      : localSalesData.map(sale => <tr>
        <td>{formatDate(sale.tstamp)}</td>
        <td>{sale.choice}</td>
        <td>{Euro.format(sale.gross)}</td>
        <td>{sale.status == 'deposit_return' || sale.status == 'success' ? paymentTypes[sale.payment_type] : statusNames[sale.status]}</td>
      </tr>));
    setSalesContent(
      <table className="ui unstackable table">
        <thead>
          <tr>
            <th>Datum</th>
            <th>Wahl</th>
            <th>Preis</th>
            <th>Bezahlung</th>
          </tr></thead>
        <tbody>
          {salesRows}
        </tbody>
      </table>
    );
  }


  useEffect(() => {
    if (salesData.length == 0 && !loadingSalesData) {
      loadingSalesData = true;
      axios.post(process.env.REACT_APP_CUSTOM_URL + 'getSales', { machineId: props.machine.id }).then(response => {
        // setSalesData(response.data.sales);
        salesData = response.data.sales;
        updateSalesData(response.data.sales);
        loadingSalesData = false;
      }).catch(function (error) {
        setSalesContent(<div className="ui negative message">
          <div className="header">
            Fehler
          </div>
          <p>Die Verkaufsdaten konnten nicht geladen werden</p>
        </div>);
        loadingSalesData = false;
      });
    }
    else {
      updateSalesData(salesData);
    }
  }, []);

  return (
    <div>
      {salesContent}
    </div>
  );
}